// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__35CWM","list":"styles_list__1XNgG"};